"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (target) {
    if (+target.value <= 0 || +target.value > 10) {
        target.value = '1';
        var $popUp_1 = document.querySelector('.custom__alertPopup');
        $popUp_1.classList.add('active');
        $popUp_1.addEventListener('animationend', function () {
            $popUp_1.classList.remove('active');
        });
        return;
    }
});
